module.exports = __webpack_public_path__ + "static/img/douyin-code.47e29e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/douyin-code.png
// module id = FtnL
// module chunks = 0